// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"9ec2637f","213":"0e87af13","239":"1f92659a","453":"8ebfe079","667":"46f3b035"}[chunkId] + ".chunk.js";
};